module.exports = {
  "id": "understory tutorial 2",
  "startingScene": 0,
  "title": "2: advanced",
  "thumbnail": "/provision/projects/understory tutorial 2/tutorial 2 image.png",
  "category": "tutorial",
  "toolbar": {
    "glitches": [],
    "parts": []
  },
  "project_file": "understory tutorial 2.gbp",
  "tutorial_scripts":[
    "level1.json",
    "level2.json"
  ]
};